<div class="dialog stability-dialog">
  <div class="dialog-background" (click)="close()"></div>
  <div class="dialog-content">
    <img (click)="close()" class="close" src="/assets/images/close.svg" alt="close" width="16px" height="16px" />
    <div>
      <h2>{{ 'new_strategy.portfolio_screen.stock_ratio.stock.popup.title' | translate }}</h2>
      <p [innerHTML]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.p1' | translate"></p>
      <p [innerHTML]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.p2' | translate"></p>
      <p [innerHTML]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.p2-2' | translate"></p>
      <div *ngIf="editMode" class="actions">
        <p [innerHTML]="'new_strategy.portfolio_screen.stock_ratio.stock.popup.p3' | translate"></p>
        <p>
          <span class="icon-i-heart"></span>
          {{ 'new_strategy.portfolio_screen.stock_ratio.stock.popup.p4' | translate }}
          <a (click)="backTo(4)">{{ 'new_strategy.portfolio_screen.stock_ratio.stock.popup.cta1' | translate }}</a>
          {{ 'new_strategy.portfolio_screen.stock_ratio.stock.popup.cta1-2' | translate }}
        </p>
        <p>
          <span class="icon-i-checkbox-on"></span>
          {{ 'new_strategy.portfolio_screen.stock_ratio.stock.popup.p5' | translate }}
          <a (click)="backTo(1)">{{ 'new_strategy.portfolio_screen.stock_ratio.stock.popup.cta2' | translate }}</a>
        </p>
      </div>
    </div>
  </div>
</div>
